// extracted by mini-css-extract-plugin
module.exports = {"container":"TaskCardHeader_container__PojNN","title":"TaskCardHeader_title__jmj7S","buttonContainer":"TaskCardHeader_buttonContainer__mzuNc"};